import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/core/services/modules/common.service';

export interface DialogData {
  Id: string;
}

@Component({
  selector: 'app-dialog-economic-activity',
  templateUrl: './dialog-economic-activity.component.html',
  styleUrls: ['./dialog-economic-activity.component.scss']
})
export class DialogEconomicActivityComponent implements OnInit {

  form: FormGroup;
  constructor(public dialogRef: MatDialogRef<DialogEconomicActivityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private commonService: CommonService,
    private fb: FormBuilder) { 
      this.form = this.fb.group({
        Code: new FormControl('',Validators.required),
        Name: new FormControl('',Validators.required),
      });
      if(this.data.Id !== undefined) {
        this.commonService.getEconomicActivityId(this.data.Id).subscribe((rest: any) => {
          this.form.get('Code').setValue(rest.Code);
          this.form.get('Name').setValue(rest.Name);
        });
      }
    }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close(false);
  }

  save() {
    if(this.form.status === 'VALID') {
      if(this.data.Id !== undefined) {
        let model = {
          ...this.form.value,
          Id: this.data.Id
        }
        this.commonService.putEconomicActivityId(this.data.Id, model).subscribe(rest => {
          this.dialogRef.close(true);
        })
      } else {
        this.commonService.postEconomicActivity(this.form.value).subscribe(rest => {
          this.dialogRef.close(true);
        });
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

}
